import { render } from "./BasicTablePage.vue?vue&type=template&id=d86f580e&ts=true"
import script from "./BasicTablePage.vue?vue&type=script&lang=ts"
export * from "./BasicTablePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__